module.exports = __webpack_public_path__ + "img/pzsl.d5475a6d.jpg";